import React from 'react';

import './explanation.css';

export const Explanation = (props) => {
  return (
    <div className="company-explanation">
      <div className="company-explanation-question">
        <p className="company-explanation-title">{props.question}<span className="glyphicon glyphicon-menu-down"></span></p>
      </div>

      <div className="company-explanation-content" >
        {props.explanation}
      </div>

    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Company/components/Explanation/Explanation.js